import { useApi } from '@backstage/core-plugin-api';
import {
  Alert,
  DetailPaneList,
  DetailPanel,
  DetailPanelItem,
} from '@internal/plugin-components-react';
import { Button, Grid, LinearProgress } from '@material-ui/core';
import React from 'react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import { DateTime } from 'luxon';

import {
  clusterManagementApiRef,

} from '../../api/types';
import LastSyncInfo from './LastSyncInfo';

function replaceUndefined(data) {
  if (!data) return '-';
  return data;
}

export const MetricDetailPanel = ({
  rowData,
}

) => {
  const clusterManagementApi = useApi(clusterManagementApiRef);
  const {
    value: metric,
    loading: isFetchingMetric,
    retry: refetchMetric,
    error: metricErrorRes,
  } = useAsyncRetry(
    async () =>
      clusterManagementApi.getMetric(rowData.environment_application_id),
    [],
  );

  if (metricErrorRes)
    return (
      React.createElement(Alert, {
        severity: "error",
        title: "Fetch metric error"  ,
        message: "Oops! An error occurred while fetching metric, please reach out to our support team for help."               ,
        defaultExpanded: true,}
      
        , React.createElement(Button, {
          variant: "contained",
          color: "secondary",
          onClick: () => refetchMetric(),}
        , "Retry"

        )
      )
    );

  if (!metric || isFetchingMetric) return React.createElement(LinearProgress, { color: "secondary",} );

  const {
    hpa: { active_replica, min_hpa, max_hpa },
    responses: { ['2xx']: resp_2xx, ['4xx']: resp_4xx, ['5xx']: resp_5xx },
    last_sync_at,
  } = metric;
  // Need to use Math.abs to remove negative.
  // The value is always negative because last_sync_at is always before than current time.
  const lastSyncInSeconds = Math.abs(
    DateTime.fromSeconds(last_sync_at).diffNow().as('seconds'),
  );

  return (
    React.createElement(React.Fragment, null
      , React.createElement(DetailPanel, null
        , React.createElement(Grid, { item: true, xs: 12,}
          , React.createElement(LastSyncInfo, {
            lastSyncInSecond: lastSyncInSeconds,
            sync: () => refetchMetric(),}
          )
        )
        , React.createElement(DetailPaneList, { label: "Horizontal Pod Autoscaler"  ,}
          , React.createElement(DetailPanelItem, {
            title: "Active Replicas" ,
            value: `${replaceUndefined(active_replica)}`,}
          )
          , React.createElement(DetailPanelItem, { title: "Min. HPA" , value: replaceUndefined(min_hpa),} )
          , React.createElement(DetailPanelItem, { title: "Max. HPA" , value: replaceUndefined(max_hpa),} )
        )
        , React.createElement(DetailPaneList, { label: "Responses",}
          , React.createElement(DetailPanelItem, {
            title: "Response 2xx" ,
            value: `${replaceUndefined(resp_2xx)}%`,}
          )
          , React.createElement(DetailPanelItem, {
            title: "Response 4xx" ,
            value: `${replaceUndefined(resp_4xx)}%`,}
          )
          , React.createElement(DetailPanelItem, {
            title: "Response 5xx" ,
            value: `${replaceUndefined(resp_5xx)}%`,}
          )
        )
      )
    )
  );
};
